export const Language = {
      ENGLISH : "en",
      FRENCH  : "fr"
}

export const Confirm = {
      YES: "Y",
      NO: "N"
}

export const Country = {
      CANADA: '1700',
      USA:    '4100'
}

export const Code = {
      NotFound: '-1',   
      DIVIDER: '-2',    
      NotApplicable: '-4',
      Unknown: '-8'
}

export const BirthPlace = {
      Hospital:"HO",
      BirthCenter:"BC",
      Home:"HM",
      Other:"OT"
}

export const Attendent  = {
        Doctor:"physician",
        Midwife:"midwife",
        Other:"other"
}
